'use client';

import { useProductDetails } from '@app/pdp/hooks';
import { getEcommerceInfo } from '@app/pdp/utils/mapToAnalytics';
import {
    Analytics,
    DigitalData,
    TrackingEvents,
    getNavigationId,
    getNavigationName,
    processFindingMethod,
    trackPDPFindingMethod,
    trackViewSearchResultsPdp,
    useAnalyticsContext,
} from '@libs/analytics';
import { usePageLayout } from '@libs/common-next';
import { useEffect, useLayoutEffect } from 'react';

export default function ProductDetailsAnalytics() {
    const { ocapi } = usePageLayout();
    const { selectedProduct: analyticsProduct, product: masterProduct } =
        useProductDetails();

    const isDefault = masterProduct.defaultVariant
        ? masterProduct.defaultVariant.objectID === analyticsProduct?.objectID
        : true;

    const { getSearchStats, setSearchStats } = useAnalyticsContext();

    const { searchTerm, searchType, searchResults, isSuggestedProduct } =
        getSearchStats();

    useLayoutEffect(() => {
        if (isSuggestedProduct) {
            trackViewSearchResultsPdp(
                searchTerm,
                searchResults ?? 1,
                searchType
            );
            setSearchStats({ searchTerm }); // clear search data to avoid double firing, but leave searchTerm for other events
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps -- we want to trigger for search
    }, [searchTerm, searchResults, searchType, isSuggestedProduct]);

    useEffect(() => {
        // Legacy thing, remove it when legacy is gone
        window.sessionStorage.currentPage = 'pdp';

        const findingMethod = processFindingMethod(
            window.sessionStorage.pdpFindingMethod
        );

        Analytics.on(TrackingEvents.VIEW_ITEM, {
            ecommerce: getEcommerceInfo({
                product: analyticsProduct,
                ocapi: ocapi.data ?? null,
                listInfo: {
                    id: getNavigationId(findingMethod),
                    name: getNavigationName(findingMethod),
                },
                categoryInfo: {
                    primaryCategoryId: Number(
                        masterProduct?.primary_category_id ?? '0'
                    ),
                    categories: masterProduct?.categories ?? null,
                },
                isDefaultProduct: isDefault,
                eventType: 'view_item',
                lastSearchQuery: searchTerm,
            }),
        });

        trackPDPFindingMethod(findingMethod);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- we want to trigger only once
    }, []);

    return <DigitalData product={analyticsProduct} />;
}
